module.exports = __webpack_public_path__ + "img/logo-max.3069279e.png";